import type { Dictionary } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import type { UUID as DEPRECATED_UUID } from 'short-uuid';
import type { BaseEntity } from '../base';
import type { FormError } from '../components';
import type { DocumentState } from '../store';
import type { UUID } from '../utils';

// eslint-disable-next-line no-shadow
export enum DocumentType {
  DOCUMENT = 'document',
  FOLDER = 'folder',
  PLUGIN = 'plugin',
  PLUGINS = 'plugins',
  PLUGINS_FOLDER = 'plugins-folder',
}

export type DocumentId = DEPRECATED_UUID | UUID;
export type ActionId = UUID;

export type RouteParams = {
  documentId: DocumentId;
};

export interface UseCase<T = unknown> {
  execute: (arg: T) => unknown;
}

export type DocumentsList<T> = Dictionary<DocumentState<T extends BaseEntity ? T : never>>;

export interface DocumentErrorsList {
  [x: DocumentId]: FormError[];
}

export type DocumentRevision = number;

export type Attachment = {
  id: DEPRECATED_UUID | UUID;
  fileName: string;
};

export type AttachmentId = `${Attachment['id']}_${Attachment['fileName']}`;

export type DocumentWithChildren<T = unknown> = T & { children?: DocumentWithChildren<T>[] };

export type UserId = DEPRECATED_UUID | UUID;
